import React from "react";
import "./About.css";
import teamPhoto from "../../1000035461.jpg";

function About() {
    return (
        <div className="about-page">
            <header className="about-header">
                <div className="header-content">
                    <h1>About KrisCars4 Ltd</h1>
                    <p>Learn about our journey, our values, and the people behind the service.</p>
                </div>
            </header>

            <main className="about-main">
                <section className="about-story">
                    <div className="story-image">
                        <img src={teamPhoto} alt="KrisCars4 Ltd Team" />
                    </div>
                    <div className="story-text">
                        <h2>Our Story: A Passion for Quality Vehicles</h2>
                        <p>
                            Founded in 2015, KrisCars4 Ltd started with a simple mission: to provide reliable, high-quality commercial vehicles and parts to our community. We saw a need for an honest, no-nonsense garage where customers could feel confident in their purchase.
                        </p>
                        <p>
                            Over the years, we've grown from a small operation into a trusted local name, but our core values remain the same. We believe in quality over quantity, and every vehicle we sell is personally inspected to meet our rigorous standards.
                        </p>
                    </div>
                </section>

                <section className="about-values">
                    <h2>Why Choose Us?</h2>
                    <div className="values-grid">
                        <div className="value-item">
                            <h3>Honesty & Transparency</h3>
                            <p>We provide clear information and fair pricing on all our vehicles and services.</p>
                        </div>
                        <div className="value-item">
                            <h3>Expertise You Can Trust</h3>
                            <p>With decades of combined experience, our team knows vehicles inside and out.</p>
                        </div>
                        <div className="value-item">
                            <h3>Customer Focused</h3>
                            <p>Your satisfaction is our top priority. We're here to help you find the perfect solution.</p>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default About;